<template>
  <FramedContainer class="w-full " :colors="colors" :background-variant="backgroundVariant">
    <div class="flex flex-col w-full h-full">
      <!-- Use Carousel Component -->
      <div class="p-2" v-if="post.images.length > 0">
        <CarouselView  class="min-h-[30rem] rounded" :slides="post.images"/>
      </div>

      <!-- Post Content -->
      <div class="p-6  dark2:bg-gray-900">
        <h2 class="text-2xl font-bold" style="color: var(--theme-text-heading);">
          {{ post.title }}
        </h2>
        <p class="mt-2" style="color: var(--theme-text-body);">
          {{ post.summary }}
        </p>
        <div v-if="post.images?.length === 0" class="h-32"></div>

        <!-- Social Media & Read More -->
        <div class="mt-4 flex justify-between items-center">
          <div class="flex space-x-3">
            <button @click="share('facebook')" class="text-blue-600 hover:text-blue-800 transition">
              <Facebook class="w-5 h-5"/>
            </button>
            <button @click="share('twitter')" class="text-gray-800 hover:text-blue-600 transition">
              <X class="w-5 h-5"/>
            </button>
            <button @click="share('instagram')" class="text-pink-500 hover:text-pink-700 transition">
              <Instagram class="w-5 h-5"/>
            </button>
          </div>

          <WebButton @click="viewPost">
            Read More
          </WebButton>
        </div>
      </div>
    </div>
  </FramedContainer>
</template>

<script setup>
import CarouselView from "@/components/CarouselPanel.vue";
import WebButton from "@/components/WebButton.vue";
import {Facebook, Instagram, X} from "@iconoir/vue";
import FramedContainer from "@/components/FramedContainer.vue";
import router from "@/router/index.js";
import {useBackLinks} from "@/composables/useBackLinks.js";
const back = useBackLinks();

const props = defineProps({
  post: {type: Object, required: true},
  colors: {type: Object, required: false, default: () => ({})},
  backgroundVariant: {type: Number, default: 1}
});

const viewPost = () => {
  router.push(back(`/post/${props.post.slug}`));
};

const share = (platform) => {
  const url = encodeURIComponent(`${window.location.origin}/post/${props.post.slug}`);
  let shareUrl = '';

  if (platform === 'facebook') {
    shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  } else if (platform === 'twitter') {
    shareUrl = `https://twitter.com/intent/tweet?url=${url}`;
  } else if (platform === 'instagram') {
    // Instagram does not support direct URL sharing
    shareUrl = `https://www.instagram.com/`;
  } else {
    return;
  }

  window.open(shareUrl, '_blank');
};
</script>
